import { render } from "./ShowItem.vue?vue&type=template&id=7d54a42f"
import script from "./ShowItem.vue?vue&type=script&lang=js"
export * from "./ShowItem.vue?vue&type=script&lang=js"

import "./ShowItem.vue?vue&type=style&index=0&id=7d54a42f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__